import React from 'react';
import PropTypes, { any } from 'prop-types';

import { FilterModal, FilterSection } from './Filter';
import UtrFitFilter from './FilterComponents/UtrFitFilter';
import styles from '../search.scss';
import { ratingTypes } from '../../../utils/constants';
import { gtag } from '../../../components/Analytics/gtag';

const CollegeUtrFitFilter = (props) => {
    const { filters, filterInputs, handleFilterClick, filterModal, closeModals, handleFilterSubmit, handleFilterUpdate, userLoggedIn, 'data-testid': dataTestId } = props;
    const filterName = 'utrFit';

    const onFilterApply = () => {
        gtag('search-filter', {
            category: 'Search Filter',
            context: `College Fit Tool Clicked`,
            location: 'Player Tags Filter',
        });
        // segment track calls for UTR College Fit filter click - mapped to GA4
        if (window?.analytics) {
            window.analytics.track('College Fit Tool Clicked', {
                userId: userLoggedIn?.id,
            });
        }
        handleFilterSubmit();
    };

    return (
        <div className={styles.filterWrapper}>
            <button
                type="button"
                className={`btn text-capitalize ${(filters?.utrFitRating) || filterModal === filterName ? `${styles.searchFilterBtn} ${styles.searchFilterBtnActive}` : `${styles.searchFilterBtnHighlighted}`}`}
                onClick={() => handleFilterClick(filterName)}
                data-testid={dataTestId && `${dataTestId}.btn`}
            >
                {ratingTypes.tennis} College Fit
            </button>
            {filterModal === filterName && (
                <FilterModal
                    title={`${ratingTypes.tennis} College Fit`}
                    handleFilterSubmit={onFilterApply}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <UtrFitFilter
                            filterInputs={filterInputs}
                            handleUtrFitPositionChange={(utrFitPosition) => {
                                handleFilterUpdate({ utrFitPosition });
                            }}
                            handleUtrFitRatingChange={(e) => {
                                handleFilterUpdate({ utrFitRating: e.target.value });
                            }}
                            data-testid={dataTestId && `${dataTestId}.utr-fit`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

CollegeUtrFitFilter.propTypes = {
    filters: PropTypes.objectOf(any).isRequired,
    filterInputs: PropTypes.objectOf(any).isRequired,
    handleFilterClick: PropTypes.func.isRequired,
    filterModal: PropTypes.string.isRequired,
    closeModals: PropTypes.func.isRequired,
    handleFilterSubmit: PropTypes.func.isRequired,
    handleFilterUpdate: PropTypes.func.isRequired,
    'data-testid': PropTypes.string,
};

CollegeUtrFitFilter.defaultProps = {
    'data-testid': undefined,
};

export default CollegeUtrFitFilter;
